import { render } from "./ChildPrivacyPolicy20250422Content.vue?vue&type=template&id=9d6594d6"
import script from "./ChildPrivacyPolicy20250422Content.vue?vue&type=script&lang=js"
export * from "./ChildPrivacyPolicy20250422Content.vue?vue&type=script&lang=js"

import exportComponent from "/apps/srv/jenkins/workspace/feihua_fe_mqimengweb_online/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__